<template>
  <side-bar
    v-show="isSidebarActiveLocal"
    position-right
    class="z-10 max-w25 mt-20"
  >
    <div class="flex sidebar-topfixpart bg-primary justify-between p-4">
      <h2 class="h2-class font-semibold text-white">ADD TAGS</h2>

      <feather-icon
        icon="XIcon"
        @click="isSidebarActiveLocal = false"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <div class="p-4">
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Tags</p>
        <b-input placeholder="Enter  Tags..." />
      </div>
    </div>
    <footer class="footer-fix fixed bottom-0 w-1/4">
      <base-button block type="primary" class="rounded-none font-semibold"
        >SUBMIT</base-button
      >
    </footer>
  </side-bar>
</template>
<script>
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {};
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
  },
};
</script>
